import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder, LogLevel, HttpTransportType } from '@microsoft/signalr';
import { Subject } from 'rxjs';
import { ApiService } from '../api/api.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { appSettings } from '../../modules/shared/components/appSettings';
import { AppSettingsService } from '../app-settings/app-settings.service';
import { IdentityAuthService } from '@services/identity-auth/identity-auth.service';

@Injectable()
export class SignalRService {
  newNotification = new Subject<any>();
  workflow = new Subject<any>();
  siteList = new Subject<any>();
  scanInstanceList = new Subject<any>();
  dashboardWidgetData = new Subject<any>();
  connectionEstablished = new Subject<Boolean>();
  connected: boolean = false;
  private hubConnection: HubConnection;

  constructor(private apiService: ApiService,
    private oauthService: OAuthService,
    private appSettingsService: AppSettingsService) {
    //this.createConnection();

  }

  sendChatMessage(message: any) {
    this.hubConnection.invoke('SendMessage', message);
  }

  public async createConnection() {

    this.hubConnection = new HubConnectionBuilder()
      .withUrl(appSettings.apiServiceAddress + '/notification', {
        accessTokenFactory: () => this.oauthService.getAccessToken(),
        transport: HttpTransportType.LongPolling
      })
      .build();
    this.registerOnServerEvents();
    this.startConnection();
  }


  private startConnection(): void {
    var _th = this;
    this.hubConnection
      .start()
      .then(() => {
        console.log('Hub connection started');
        this.connectionEstablished.next(true);
        this.connected = true;
      })
      .catch(err => {
        console.log('Error while establishing connection, retrying...');
        setTimeout(function () {
          _th.startConnection()
        }, 5000);
      });
  }

  private registerOnServerEvents(): void {
    this.hubConnection.on('Notification', (data: any) => {
      this.newNotification.next(data);
    });

    this.hubConnection.on('Workflow', (data: any) => {
      this.workflow.next(data);
    });
    

    this.hubConnection.onclose(o => {
      var _th = this;
      this.connected = false;
      setTimeout(function () {
        _th.startConnection()
      }, 5000);
    })
  }
}
